import React from 'react';
import { themr } from '@friendsofreactjs/react-css-themr';
import Button, { propTypes as buttonPropTypes } from './Button';
import { CONTAINED, OUTLINED, TEXT } from './types';

const { variant, ...propTypes } = buttonPropTypes;

const ContainedButtonComponent = props => <Button { ...props } variant={ CONTAINED } />;
ContainedButtonComponent.propTypes = propTypes;

const TextButtonComponent = props => <Button { ...props } variant={ TEXT } />;
TextButtonComponent.propTypes = propTypes;

const OutlinedButtonComponent = props => <Button { ...props } variant={ OUTLINED } />;
OutlinedButtonComponent.propTypes = propTypes;

export const ContainedButton = themr('ContainedButton')(ContainedButtonComponent);
export const TextButton = themr('TextButton')(TextButtonComponent);
export const OutlinedButton = themr('OutlinedButton')(OutlinedButtonComponent);

const buttonsByType = {
    [CONTAINED]: ContainedButton,
    [OUTLINED]: OutlinedButton,
    [TEXT]: TextButton,
};
const getButtonByType = type => buttonsByType[type] || Button;

export {
    propTypes,
    getButtonByType,
};
